import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

import "./styles/globals.css";

import Home from "./Home";
import ChineseHoroscope from "./Chinese-Horoscope";
import ChineseZodiac from "./chinese-zodiac";
import ZodiacDetails from "./chinese-zodiac/ZodiacDetails";
import ElementZodiacPage from "./five-elements-zodiac/[slug]";
import About from "./Aboutus";
import Directory from "./Directory";
import Privacy from "./Privacy-Policy";
import Contact from "./Contact";
import ResetPassword from "./ResetPassword";
import Login from "./Login";
import Register from "./Register";
import Subscribe from "./Subscribe";
import ForgotPassword from "./ForgotPassword";
import SubscribeCheckout from "./SubscribeCheckout";
import SubscribeSuccess from "./SubscribeSuccess";
import RegisterSuccess from "./RegisterSuccess";
import Dashboard from "./Dashboard";
import Checkout from "./Checkout";
import SetPassword from "./SetPassword";

import ThankYou from "./Components/checkout/ThankYou.jsx";
import PaymentFailed from "./Components/checkout/PaymentFailed.jsx";

const GA_TRACKING_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

function GAListener() {
  const location = useLocation();

  useEffect(() => {
    if (!GA_TRACKING_ID) return;

    // init only once
    ReactGA.initialize(GA_TRACKING_ID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!GA_TRACKING_ID) return;
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location.pathname]);

  return null;
}

export default function App() {
  return (
    <Router>
      <GAListener />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Chinese-Horoscope" element={<ChineseHoroscope />} />
        <Route path="/chinese-zodiac" element={<ChineseZodiac />} />
        <Route path="/chinese-zodiac/:slug" element={<ZodiacDetails />} />
        <Route path="/five-elements-zodiac/:slug" element={<ElementZodiacPage />} />

        <Route path="/Aboutus" element={<About />} />
        <Route path="/Directory" element={<Directory />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Privacy-Policy" element={<Privacy />} />

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/subscribe/checkout" element={<SubscribeCheckout />} />
        <Route path="/subscribe/success" element={<SubscribeSuccess />} />
        <Route path="/dashboard" element={<Dashboard />} />

        <Route path="/checkout" element={<Checkout />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/paymentfailed" element={<PaymentFailed />} />

        <Route path="/register-success" element={<RegisterSuccess />} />
        <Route path="/set-password" element={<SetPassword />} />
      </Routes>
    </Router>
  );
}
